<template>
  <div>
    <div class="banner">
      <img src="../../assets/images/bg.jpg" />
    </div>
    <div class="main">
      <div class="com-page-title">
        <div class="inner">订单详情</div>
      </div>
      <div class="com-card">
        <div class="com-card-title">{{ orderName }}</div>
        <div class="com-card-content" v-if="payload">
          <!--法会牌位-->
          <div v-if="orderType.key == 'fawu-fahui-paiwei'">
            <h3>牌位信息</h3>
            <template v-if="!payload.isLordofmerit">
              <p>类型 :
                <DictionaryText typeCode="gongfengfangshi" :dictValue="payload.way"/>
              </p>
              <p>牌位 :
                <DictionaryText typeCode="paiweidaxiao" :dictValue="payload.size"/>
              </p>
            </template>
            <p v-else>类型 : 大功德主</p>
            <p>订单金额 : {{ payload.price }} 元</p>
            <van-collapse v-model="collapseActiveNames">
              <!-- 超荐莲位 -->
              <van-collapse-item name="1" v-if="lianWeiList.length">
                <template #title>
                  <div style="font-weight:700;font-size:16px">
                    <DictionaryText typeCode="gongfengfangshi" :dictValue="payload.way" v-if="!payload.isLordofmerit" />
                    <span v-else>超荐莲位</span>
                  </div>
                </template>
                <template v-for="(lst, index) in lianWeiList" :key="index">
                  <div v-for="(deadItem, deadIndex) in lst.deadList" :key="deadIndex">
                    <h3>往生者信息{{lianWeiList.length > 1 ? '(' + (index + 1) + ')' : ''}}</h3>
                    <p>称谓 : {{ deadItem.deadAppellation }}</p>
                    <p>姓名 : {{ deadItem.deadName }}</p>
                    <div v-if="[245, 315].includes(Number(orderType.pId))">
                      <p>生于 : {{ deadItem.birthDate }}</p>
                      <p>卒于 : {{ deadItem.deathDate }}</p>
                      <p v-if="index == 0">在世时家庭住址 : {{ deadItem.address }}</p>
                    </div>
                  </div>
                  <div>
                    <h3>供奉人信息{{lianWeiList.length > 1 ? '(' + (index + 1) + ')' : ''}}</h3>
                    <p>姓名 : {{ lst.worshipperName }}</p>
                    <p>联系方式 : {{ lst.mobile }}</p>
                    <p v-if="!payload.isLordofmerit">尺寸规格 :
                      <DictionaryText typeCode="chicunguige" :dictValue="payload.specification"/>
                    </p>
                    <p>供奉时间 : {{ payload.date }}</p>
                    <p v-if="!(payload.way?.indexOf('quannian') != -1)">供奉位置 :
                      <DictionaryText typeCode="gongfengweizhi" :dictValue="payload.location"/>
                    </p>
                  </div>
                  <br v-if="index < lianWeiList.length - 1" />
                </template>
              </van-collapse-item>
              <!-- 延生禄位 -->
              <van-collapse-item name="2" v-if="luWeiList.length">
                <template #title>
                  <div style="font-weight:700;font-size:16px">
                    <DictionaryText typeCode="gongfengfangshi" :dictValue="payload.way" v-if="!payload.isLordofmerit" />
                    <span v-else>延生禄位</span>
                  </div>
                </template>
                <div v-for="(lst, index) in luWeiList" :key="index">
                  <h3>供奉人信息{{ luWeiList.length > 1 ? '(' + (index + 1) + ')' : '' }}</h3>
                  <p>姓名 : {{ lst.worshipperName }}</p>
                  <p v-if="$getSpecialReligiousAssemblyRecord([225, 245, 249, 309, 311, 312, 313, 315]).includes(Number(payload.pId))">生于 : {{ lst.livingBirthDate }}</p>
                  <p>联系方式 : {{ lst.mobile }}</p>
                  <p v-if="!payload.isLordofmerit">尺寸规格 :
                    <DictionaryText typeCode="chicunguige" :dictValue="payload.specification"/>
                  </p>
                  <p>供奉时间 : {{ payload.date }}</p>
                  <p v-if="!(payload.way?.indexOf('quannian') != -1)">供奉位置 :
                    <DictionaryText typeCode="gongfengweizhi" :dictValue="payload.location"/>
                  </p>
                  <p v-if="$getSpecialReligiousAssemblyRecord([225, 245, 249, 309, 311, 312, 313, 315]).includes(Number(orderType.pId))">家庭住址 : {{lst.livingAddress }}</p>
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
          <!--法会报名-->
          <div v-if="orderType.key == 'fawu-fahui-baoming'">
            <!-- 皈依法会 -->
            <template v-if="orderType.way == 'guiyi'">
              <h3>求授皈依者信息</h3>
              <p>姓名 : {{ payload.jingciOrderGuiyiUser.name }}</p>
              <p>性别 : {{ payload.jingciOrderGuiyiUser.sex }}</p>
              <p>年龄 : {{ payload.jingciOrderGuiyiUser.age }}</p>
              <p>身份证号 : {{ payload.jingciOrderGuiyiUser.idCartNum }}</p>
              <p>地址 : {{ payload.jingciOrderGuiyiUser.address }}</p>
              <p>联系方式 : {{ payload.jingciOrderGuiyiUser.mobile }}</p>
              <p v-if="payload.price > 0">订单金额 : {{ payload.price + ' 元' }}</p>
              <p>法会时间 : {{ payload.date }}(农历)·上午9：00</p>
              <p>法会地点 : {{ payload.location }}</p>
              <p>参与人员 : {{ payload.participants }}</p>
            </template>
            <template v-else>
              <h3>参加者信息</h3>
              <p>姓名 : {{ payload.worshipperName }}</p>
              <p>联系方式 : {{ payload.mobile }}</p>
              <p>是否供灯 : <span v-if="payload.goodsNum > 0">是</span><span v-else>否</span></p>
              <p v-if="payload.goodsNum > 0">供灯数量 : {{ payload.goodsNum }}</p>
              <p>订单金额 : {{payload.price+' 元'}}</p>
              <p>法会时间 : {{ payload.date }}(农历)·18:45 - 20:45</p>
              <p>法会地点 : {{ payload.location }}</p>
              <p>参与人员 : 全体僧众及护法善信</p>
            </template>
          </div>
          <!--日常佛事-->
          <div v-if="orderType.key == 'fawu-foshi'">
            <h3>供奉人信息</h3>
            <p>姓名 : {{ payload.worshipperName }}</p>
            <p>联系方式 : {{ payload.mobile }}</p>
            <p>尺寸规格 : 纸质斋条</p>
            <p>订单金额 : {{payload.price}} 元</p>
            <p>供奉时间 : {{time}}</p>
            <p>供奉位置 :
              <DictionaryText typeCode="gongfengweizhi" :dictValue="payload.location"/>
            </p>
          </div>
          <!-- 广种福田 -->
          <div v-if="orderType.key == 'fawu-futian'">
            <h3>功德主信息</h3>
            <p>姓名 : {{ payload.worshipperName }}</p>
            <p>联系方式 : {{ payload.mobile }}</p>
            <!-- 随喜金额 -->
            <div v-if="orderType.type == 0">
              <p>随喜金额 : {{payload.price}} 元</p>
            </div>
            <!-- 祈福、供灯 -->
            <div v-else-if="orderType.type == 1">
              <p>{{payload.goodsName.indexOf('祈福') != -1 ? '祈福时间 :' : '供灯时间 :'}} {{ payload.date }}</p>
              <p>{{payload.goodsName.indexOf('祈福') != -1 ? '祈福位置 :' : '供灯位置 :'}}
                <DictionaryText typeCode="jiNianRiWeiZhi" :dictValue="payload.location"/>
              </p>
              <p>供灯数量 : {{ payload.goodsNum }}</p>
            </div>
            <!-- 纪念日 -->
            <div v-else-if="orderType.type == 2">
              <p>供灯选择 : {{ anniversaryData?.anniversaryName }}</p>
              <p>供灯时间 : {{ anniversaryData?.date }}</p>
              <p>供灯位置 :
                <DictionaryText typeCode="jiNianRiWeiZhi" :dictValue=" anniversaryData?.location"/>
              </p>
              <p>供灯数量 : {{ payload.goodsNum }}/对</p>
            </div>
            <!-- 功德林 -->
            <div v-else-if="orderType.type == 3">
              <p>林木品种 : {{ treeData?.treeName }}</p>
              <p>林木规格 : {{ treeData?.specification }}</p>
              <p>认供数量 : {{ payload.goodsNum }}</p>
            </div>
            <p v-if="orderType.type != 0">订单金额 : {{payload.price}} 元</p>
            <p v-if="[264, 267, 270, 314].includes(orderType.pId)">祈福语 : {{ payload.blessingWords }}</p>
          </div>
          <div class="marginTop">
            <h3>订单信息</h3>
            <p>订单编号 : {{payload.orderSn}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DictionaryText from '@/components/common/DictionaryText'

  export default {
    name: "orderDetail",
    data() {
      return {
        collapseActiveNames: ['1', '2'],
        orderName:this.$route.query.orderName,
        id: this.$route.query.orderId,
        payload: null,
        orderType: null,
        anniversaryData: null,
        treeData: null,
        time:null,
        // 超荐莲位列表
        lianWeiList: [],
        // 䘵位列表
        luWeiList: []
      }
    },
    mounted() {
      this.getOrderDetail()
    },
    methods: {
      getOrderDetail() {
        this.$orderApi.getOrderDetail({
          orderId: this.id
        }).then(res => {
          if (res.success) {
            this.payload = res.data
            this.lianWeiList = res.data.liveList.filter(v => v.deadList?.length)
            this.luWeiList = res.data.liveList.filter(v => !v.deadList?.length)
            this.orderType = JSON.parse(res.data.orderType)
            // 纪念日
            if (this.orderType.type == 2) {
              this.getAnniversaryData()
            }
            // 林木
              else if (this.orderType.type == 3) {
              this.getTreeData()
            }
            //供斋
            else if(this.orderType.key == 'fawu-foshi') {
              if (this.payload.date){
                let date = JSON.parse(this.payload.date)
                if (date.start == date.end) {
                  this.time = date.start
                } else {
                  this.time = date.start + '至' + date.end
                }
              } else {
                this.time = '由寺院随机安排'
              }
            }
          } else {
            this.$toast(res.errMessage)
          }
        })
      },
      // 纪念日详情
      getAnniversaryData () {
        this.$faWuApi.fuTian.getDateData({
          id: this.orderType.anniversaryId
        }).then(res => {
          if (res.success) {
            this.anniversaryData = res.data
          }
        })
      },
      // 林木详情
      getTreeData () {
        this.$faWuApi.fuTian.getTreeData({
          id: this.orderType.treeId
        }).then(res => {
          if (res.success) {
            this.treeData = res.data
          }
        })
      }
    },
    components: {
      DictionaryText
    }
  }
</script>

<style lang="less" scoped>
  ::v-deep(.van-collapse-item) {
    .van-cell,.van-collapse-item__content {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
  .banner {
    height: 300px;
  }

  .banner img {
    width: 100%;
    height: 100%;
  }
  .com-card-title span{
      float:right;
  }

  .com-card-content h3 {
    margin-bottom: 10px;
    font-size:16px;
    color: #B27532;
  }

  .marginTop {
    margin-top: 10px;
  }

  p {
    line-height: 25px;
    font-size:14px;
  }
</style>
